import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInbox = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 10.75v4.5a2 2 0 0 0 2 2h12.5a2 2 0 0 0 2-2v-4.5m-16.5 0 1.621-6.485a2 2 0 0 1 1.94-1.515h9.377a2 2 0 0 1 1.94 1.515l1.622 6.485m-16.5 0h2.764a2 2 0 0 1 1.789 1.106l.144.288a2 2 0 0 0 1.79 1.106h3.527a2 2 0 0 0 1.789-1.106l.144-.288a2 2 0 0 1 1.79-1.106h2.763"
	})]
});
const ForwardRef = forwardRef(SvgInbox);
export { ForwardRef as ReactComponent };
